var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-plane',{attrs:{"width":_vm.x,"height":_vm.y,"color":_vm.groundColor,"material":"roughness: 0.75"}})}
var staticRenderFns = []

export { render, staticRenderFns }